import { useState, useEffect } from "react"
import axios from "axios"
import { useSelector } from "react-redux"

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const BASE_URL = process.env.REACT_APP_API_BASE_URL

const SocialProfileSettings = () => {
  const accessToken = useSelector((state) => state.auth.access)
  const [loading, setLoading] = useState(false)
  const [socialData, setSocialData] = useState({
    facebook: "",
    twitter: "",
    linkedin: "",
    website: "",
    github: "",
  })

  useEffect(() => {
    axios.get(`${BASE_URL}/users/social-profile/`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    }).then((res) => {
      setSocialData(res.data)
    }).catch((err) => {
      console.warn("No existing social profile found.")
    })
  }, [accessToken])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setSocialData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    try {
      await axios.post(
        `${BASE_URL}/users/social-profile/`,
        socialData,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      )
      toast.success("Social profile updated successfully!")
    } catch (err) {
      //console.error(err.response?.data || err)
      toast.error("Failed to update social profile.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="social-profile-settings">
      <h5 className="mb-4">Social Profile Link</h5>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="facebook" className="form-label d-flex align-items-center">
            <i className="fab fa-facebook me-2"></i> Facebook
          </label>
          <input
            type="url"
            className="form-control"
            id="facebook"
            name="facebook"
            value={socialData.facebook}
            onChange={handleInputChange}
            placeholder="https://facebook.com/username"
          />
        </div>

        <div className="mb-3">
          <label htmlFor="twitter" className="form-label d-flex align-items-center">
            <i className="fab fa-twitter me-2"></i> Twitter
          </label>
          <input
            type="url"
            className="form-control"
            id="twitter"
            name="twitter"
            value={socialData.twitter}
            onChange={handleInputChange}
            placeholder="https://twitter.com/username"
          />
        </div>

        <div className="mb-3">
          <label htmlFor="linkedin" className="form-label d-flex align-items-center">
            <i className="fab fa-linkedin me-2"></i> LinkedIn
          </label>
          <input
            type="url"
            className="form-control"
            id="linkedin"
            name="linkedin"
            value={socialData.linkedin}
            onChange={handleInputChange}
            placeholder="https://linkedin.com/in/username"
          />
        </div>

        <div className="mb-3">
          <label htmlFor="website" className="form-label d-flex align-items-center">
            <i className="fas fa-globe me-2"></i> Website
          </label>
          <input
            type="url"
            className="form-control"
            id="website"
            name="website"
            value={socialData.website}
            onChange={handleInputChange}
            placeholder="https://example.com/"
          />
        </div>

        <div className="mb-4">
          <label htmlFor="github" className="form-label d-flex align-items-center">
            <i className="fab fa-github me-2"></i> Github
          </label>
          <input
            type="url"
            className="form-control"
            id="github"
            name="github"
            value={socialData.github}
            onChange={handleInputChange}
            placeholder="https://github.com/username"
          />
        </div>

        <button type="submit" className="btn btn-warning" disabled={loading}>
          {loading ? "Saving..." : "Update Profile"}
        </button>
      </form>
    </div>
  )
}

export default SocialProfileSettings
